import { Directive, inject, OnDestroy } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { UserDetail } from '../../models/UserDetail.model';
import { AppState, selectUserDetailWithPermissions } from '../../ngrx/app.state';

@Directive({
    selector: '[appStateful]',
    standalone: true
})
export class StatefulComponent implements OnDestroy {

  private store = inject(Store<AppState>);
  subs = new Array<Subscription | undefined>();
  user: UserDetail | undefined;
  permissions: string[] | undefined;

  constructor() {
    this.subs.push(this.select(selectUserDetailWithPermissions).subscribe((response: { userDetail: UserDetail | undefined, permissions: string[] | undefined }) => {
      this.user = response.userDetail;
      this.permissions = response.permissions;
    }))
  }

  select(selector: any): Observable<any> {
    return this.store.select(selector);
  }

  dispatch(action: Action): void {
    this.store.dispatch(action);
  }

  ngOnDestroy(): void {
    for (let sub of this.subs) {
      if (sub) {
        sub.unsubscribe();
      }
    }
  }
}
